import { render, staticRenderFns } from "./automation-list.vue?vue&type=template&id=6b360e10"
import script from "./automation-list.vue?vue&type=script&lang=js"
export * from "./automation-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports